import React from 'react';

import { ReactComponent as IconFlagId } from '@whitelabel/media/icons/flags/localeFlags/id.svg';
import { ReactComponent as IconFlagAz } from '@whitelabel/media/icons/flags/localeFlags/az.svg';
import { ReactComponent as IconFlagMs } from '@whitelabel/media/icons/flags/localeFlags/ms.svg';
import { ReactComponent as IconFlagCs } from '@whitelabel/media/icons/flags/localeFlags/cs.svg';
import { ReactComponent as IconFlagDa } from '@whitelabel/media/icons/flags/localeFlags/da.svg';
import { ReactComponent as IconFlagDe } from '@whitelabel/media/icons/flags/localeFlags/de.svg';
import { ReactComponent as IconFlagEt } from '@whitelabel/media/icons/flags/localeFlags/et.svg';
import { ReactComponent as IconFlagEl } from '@whitelabel/media/icons/flags/localeFlags/el.svg';
import { ReactComponent as IconFlagFil } from '@whitelabel/media/icons/flags/localeFlags/fil.svg';
import { ReactComponent as IconFlagFr } from '@whitelabel/media/icons/flags/localeFlags/fr.svg';
import { ReactComponent as IconFlagHr } from '@whitelabel/media/icons/flags/localeFlags/hr.svg';
import { ReactComponent as IconFlagIs } from '@whitelabel/media/icons/flags/localeFlags/is.svg';
import { ReactComponent as IconFlagIt } from '@whitelabel/media/icons/flags/localeFlags/it.svg';
import { ReactComponent as IconFlagSw } from '@whitelabel/media/icons/flags/localeFlags/sw.svg';
import { ReactComponent as IconFlagLv } from '@whitelabel/media/icons/flags/localeFlags/lv.svg';
import { ReactComponent as IconFlagLt } from '@whitelabel/media/icons/flags/localeFlags/lt.svg';
import { ReactComponent as IconFlagHu } from '@whitelabel/media/icons/flags/localeFlags/hu.svg';
import { ReactComponent as IconFlagMt } from '@whitelabel/media/icons/flags/localeFlags/mt.svg';
import { ReactComponent as IconFlagNl } from '@whitelabel/media/icons/flags/localeFlags/nl.svg';
import { ReactComponent as IconFlagNo } from '@whitelabel/media/icons/flags/localeFlags/no.svg';
import { ReactComponent as IconFlagPl } from '@whitelabel/media/icons/flags/localeFlags/pl.svg';
import { ReactComponent as IconFlagPt } from '@whitelabel/media/icons/flags/localeFlags/pt.svg';
import { ReactComponent as IconFlagPtBr } from '@whitelabel/media/icons/flags/localeFlags/pt-br.svg';
import { ReactComponent as IconFlagRo } from '@whitelabel/media/icons/flags/localeFlags/ro.svg';
import { ReactComponent as IconFlagSk } from '@whitelabel/media/icons/flags/localeFlags/sk.svg';
import { ReactComponent as IconFlagFi } from '@whitelabel/media/icons/flags/localeFlags/fi.svg';
import { ReactComponent as IconFlagSv } from '@whitelabel/media/icons/flags/localeFlags/sv.svg';

import { ReactComponent as IconFlagVi } from '@whitelabel/media/icons/flags/localeFlags/vi.svg';
import { ReactComponent as IconFlagTr } from '@whitelabel/media/icons/flags/localeFlags/tr.svg';
import { ReactComponent as IconFlagBg } from '@whitelabel/media/icons/flags/localeFlags/bg.svg';
import { ReactComponent as IconFlagRu } from '@whitelabel/media/icons/flags/localeFlags/ru.svg';

import { ReactComponent as IconFlagUk } from '@whitelabel/media/icons/flags/localeFlags/uk.svg';
import { ReactComponent as IconFlagHe } from '@whitelabel/media/icons/flags/localeFlags/he.svg';
import { ReactComponent as IconFlagAr } from '@whitelabel/media/icons/flags/localeFlags/ar.svg';
import { ReactComponent as IconFlagTh } from '@whitelabel/media/icons/flags/localeFlags/th.svg';
import { ReactComponent as IconFlagKa } from '@whitelabel/media/icons/flags/localeFlags/ka.svg';

import { ReactComponent as IconFlagJa } from '@whitelabel/media/icons/flags/localeFlags/ja.svg';
import { ReactComponent as IconFlagZh } from '@whitelabel/media/icons/flags/localeFlags/zh.svg';
import { ReactComponent as IconFlagKo } from '@whitelabel/media/icons/flags/localeFlags/ko.svg';
import { ReactComponent as IconFlagUs } from '@whitelabel/media/icons/flags/localeFlags/us.svg';
import { ReactComponent as IconFlagGb } from '@whitelabel/media/icons/flags/rect/GB.svg';

import pngFlagCa from '@whitelabel/media/icons/flags/localeFlags/ca@3x.png';
import pngFlagEs from '@whitelabel/media/icons/flags/localeFlags/es@3x.png';
import pngFlagMx from '@whitelabel/media/icons/flags/localeFlags/es-mx@3x.png';
import pngFlagSr from '@whitelabel/media/icons/flags/localeFlags/sr@3x.png';

const IconFlagCa = () => <img src={pngFlagCa} alt="ca flag" width="25" height="16" className="flag-image" />;
const IconFlagEs = () => <img src={pngFlagEs} alt="es flag" width="25" height="16" className="flag-image" />;
const IconFlagMx = () => <img src={pngFlagMx} alt="es-mx flag" width="25" height="16" className="flag-image" />;
const IconFlagSr = () => <img src={pngFlagSr} alt="sr flag" width="25" height="16" className="flag-image" />;

export const flagMap = {
  az: IconFlagAz,
  id: IconFlagId,
  ms: IconFlagMs,
  ca: IconFlagCa,
  cs: IconFlagCs,
  da: IconFlagDa,
  de: IconFlagDe,
  et: IconFlagEt,
  el: IconFlagEl,
  es: IconFlagEs,
  'es-mx': IconFlagMx,
  fil: IconFlagFil,
  fr: IconFlagFr,
  hr: IconFlagHr,
  is: IconFlagIs,
  it: IconFlagIt,
  sw: IconFlagSw,
  lv: IconFlagLv,
  lt: IconFlagLt,
  hu: IconFlagHu,
  mt: IconFlagMt,
  nl: IconFlagNl,
  no: IconFlagNo,
  pl: IconFlagPl,
  pt: IconFlagPt,
  'pt-br': IconFlagPtBr,
  ro: IconFlagRo,
  sk: IconFlagSk,
  sl: IconFlagSk,
  fi: IconFlagFi,
  sv: IconFlagSv,

  vi: IconFlagVi,
  tr: IconFlagTr,
  bg: IconFlagBg,
  ru: IconFlagRu,
  sr: IconFlagSr,

  uk: IconFlagUk,
  he: IconFlagHe,
  ar: IconFlagAr,
  th: IconFlagTh,
  ka: IconFlagKa,

  ja: IconFlagJa,
  'zh-hans': IconFlagZh,
  'zh-hant': IconFlagZh,
  ko: IconFlagKo,
  en: IconFlagGb,
  'en-us': IconFlagUs,
};
